import { styled } from "goober";
import { shimmer } from "./motion";

export const Skeleton = styled("div")`
  height: 12px;
  border-radius: 999px;
  background: linear-gradient(
    90deg,
    var(--alpha4) 30%,
    var(--alpha8) 50%,
    var(--alpha4) 70%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 2000ms linear infinite;
`;
